import React from "react";
import BackgroundImage from "./../images/aboutus_background.webp";
import "./AboutUs.css";

const AboutUsPage = () => {
  return (
    <div className="AU-container">
      <div
        className="AU-hero"
        style={{ backgroundImage: `url(${BackgroundImage})` }}
      >
        <div className="AU-hero-content">
          <h1 className="AU-title">About Us</h1>
        </div>
      </div>

      <div className="AU-main-content">
        <div className="AU-intro-section">
          <h2 className="AU-intro-title">
            Delivering compassionate home care, right to your home
          </h2>
          <div className="AU-intro-text">
            <p>
              At iCare Village, we believe that aging should be met with
              dignity, care, and a strong sense of belonging. We are a home care
              service provider delivering reliable, non-medical in-home support
              through a dedicated care team that includes care aide students,
              nursing students, and retired care professionals – all employed by
              iCare Village.
            </p>
            <p>
              Our services are designed to help older adults remain in the
              comfort of their own homes for as long as possible. Supported by
              our technology-enabled care platform, we coordinate services that
              promote independence, safety, and meaningful connection within
              familiar surroundings and local communities.
            </p>
          </div>
        </div>

        <div className="AU-cards-grid">
          <div className="AU-core-card">
            <h2 className="AU-card-title">MISSION</h2>
            <h4 className="AU-card-subtitle">
              Connecting People with Compassionate & Reliable Home Care
            </h4>
            <p className="AU-card-desc">
              Our mission at iCare Village is to provide compassionate,
              reliable, and affordable non-medical home care services that
              enhance quality of life for older adults. By employing and
              supporting a dedicated care team, we strive to deliver consistent,
              respectful care that helps seniors live safely, comfortably, and
              meaningfully at home.
            </p>
          </div>

          <div className="AU-core-card">
            <h2 className="AU-card-title">VISION</h2>
            <h4 className="AU-card-subtitle">
              Supporting Dignity and Independence at Home
            </h4>
            <p className="AU-card-desc">
              To create a future where every senior can age at home with
              dignity, independence, and confidence – supported by compassionate
              care, thoughtful coordination, and a community that values respect
              and connection.
            </p>
          </div>

          <div className="AU-core-card">
            <h2 className="AU-card-title">VALUES</h2>
            <h4 className="AU-card-subtitle">
              Compassion, respect, dignity and affordability
            </h4>
            <p className="AU-card-desc">
              At iCare Village, our work is guided by compassion, respect,
              dignity, and affordability. We believe in caring for people as
              individuals, supporting independence, and building trust through
              reliable services delivered with empathy, professionalism, and
              accountability.
            </p>
          </div>
        </div>
      </div>

      <div className="AU-footer-banner">
        <img
          src={require(`../images/footer-aboutus-img.png`)}
          alt="About Us Footer"
          className="AU-footer-img"
        />
      </div>
    </div>
  );
};

export default AboutUsPage;
